import styled from 'styled-components';

export const Image = styled.img`
  width: 80%;
  max-width: 360px;
  transition: all 0.3s;
  object-fit: cover;
  border-radius: 6px;
  animation: animateThumb 0.5s;

  /* elevation */
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.19), 0 12px 12px rgba(0, 0, 0, 0.23);

  @keyframes animateThumb {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  /* mobile devices */
  /*@media screen and (max-width: 500px) {
    width: 60%;
  }*/
`;
